<template>
  <div class="halfClock">
    <div :class="['half_inner',btmpart?'btmpart':'']">
      <div class="num" :style="{backgroundImage: `linear-gradient(to bottom, ${textColor}, ${textColor})`}">{{num}}</div>
      <div class="blackLine" :style="{'height':lineWidth}"></div>
      <div :class="['ampm',ampm==='AM'?'am':'pm']" :style="{color: textColor}">{{ampm}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lineWidth: {
      default: '4px'
    },
    btmpart: {
      default: false
    },
    num: {
      default: 0
    },
    ampm: String,
    textColor: {
      type: String,
      default: '#bbbbbb'
    }
  }
}
</script>

<style lang="less">
.halfClock{
  height: 50%;
  overflow: hidden;
}
.half_inner{
  position: relative;
  height: 200%;
  border-radius: 12%;
  background: linear-gradient(180deg, #1e1e22 0%, #141416 100%);
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.04);
}
.btmpart{
  top: -100%;
}
.num{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  font-weight: bold;
  text-align: center;
  background: linear-gradient(180deg, #e8e8ec 0%, #a8a8b0 100%);
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));
}
.blackLine{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  background: linear-gradient(90deg, transparent 0%, rgba(0,0,0,0.6) 20%, rgba(0,0,0,0.8) 50%, rgba(0,0,0,0.6) 80%, transparent 100%);
}
.ampm{
  position: absolute;
  left: 5%;
  font-size: 3vw;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.am{
  top: 12%;
  color: #a8a8b0;
}
.pm{
  bottom: 12%;
  color: #a8a8b0;
}
</style>
